import {
  Color,
  List,
  Paragraph
} from '@eggplant/pattern-library'

const MostCommonFailsInfo = () =>
  <>
    <Paragraph>
      <Color variant='theme-description-text'>
        The top 10 test case failures report offers valuable insights into the test cases that have encountered the highest number of failures within the applied filters at the dashboard level. This report helps you prioritize troubleshooting efforts and focus on areas that require immediate attention.
      </Color>
      <br />
      <br />
      <Color variant='theme-description-text'>
        Key Features:
      </Color>
      <br />
    </Paragraph>
    <List variant='description'>
      <Paragraph>
        <Color variant='theme-description-text'>
          Fail Frequency Analysis: Identify the top 10 test cases with the highest number of failures, allowing you to pinpoint recurring issues and prioritize resolution.
        </Color>
      </Paragraph>
      <Paragraph>
        <Color variant='theme-description-text'>
          Model or Suite Association: Each test case is associated with a specific model or suite, providing context and facilitating targeted investigation.
        </Color>
      </Paragraph>
      <Paragraph>
        <Color variant='theme-description-text'>
          Detailed Test Case View: Access specific test cases directly from the report using the actions icon, enabling a focused examination of individual test case.
        </Color>
      </Paragraph>
      <Paragraph>
        <Color variant='theme-description-text'>
          Comprehensive Fail Overview: Explore all failures within each specific test case to gain a deeper understanding of the encountered issues.
        </Color>
      </Paragraph>
    </List>
    <br />
    <Paragraph>
      <Color variant='theme-description-text'>
        With the 10 test case failures report, you can efficiently address common failure scenarios, streamline debugging efforts, and improve the overall quality and reliability of your testing process.
      </Color>
    </Paragraph>
  </>

export default MostCommonFailsInfo
